import React, { useEffect, useRef, useState } from 'react'
import services from 'pages/Dashboard/services'
import useCSVDownloadProgress from 'libs/hooks/useCSVDownloadProgress'
import servicesUtils from 'libs/servicesUtils'
import _ from 'lodash'

import './index.scss'

function CSVDownloadProgress() {
  const [progress, setProgress] = useState()
  const [presignedURL, setPresignedURL] = useState()
  const { pollStatus, updatePollStatus } = useCSVDownloadProgress()
  const intervalIdRef = useRef()

  function getCSVDownloadableURL(params) {
    const url = '/csv-download'
    servicesUtils
      .getService(url, params)
      .then(response => {
        setPresignedURL(response.presigned_url)
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.log({ e })
      })
  }

  function pollCSVProgress() {
    services
      .getCSVReportStatus()
      .then(response => {
        setProgress(response)
        const stopPoll = response.status !== 'IN_PROGRESS'
        const newStatus = stopPoll ? 'idle' : 'poll'

        const IS_NOT_SAME = newStatus !== pollStatus
        if (IS_NOT_SAME) {
          updatePollStatus(newStatus)
        }

        if (stopPoll) {
          clearInterval(intervalIdRef.current)
        }

        if (response.status === 'SUCCESS') {
          clearInterval(intervalIdRef.current)
          getCSVDownloadableURL()
        }
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.log({ e })
      })
  }

  useEffect(() => {
    pollCSVProgress()
  }, [])

  useEffect(() => {
    if (pollStatus === 'poll') {
      intervalIdRef.current = setInterval(() => {
        pollCSVProgress()
      }, 10000)
    } else if (pollStatus === 'once') {
      pollCSVProgress()
      clearInterval(intervalIdRef.current)
    } else {
      clearInterval(intervalIdRef.current)
    }

    return () => {
      clearInterval(intervalIdRef.current)
    }
  }, [pollStatus])

  if (!progress) {
    return null
  }

  const progressState = progress.status

  if (progressState === 'NOT_TRIGGERED') {
    return null
  }

  const COLOR_CODE_MAP = {
    IN_PROGRESS: '#D88800',
    NOT_TRIGGERED: '',
    SUCCESS: '#00A159',
    FAILURE: '#C0333E'
  }

  const ICON_MAP = {
    IN_PROGRESS: 'fa-spinner-third rotating',
    NOT_TRIGGERED: '',
    SUCCESS: 'fa-circle-check',
    FAILURE: 'fa-diamond-exclamation'
  }

  const MESSAGE_MAP = {
    IN_PROGRESS: 'Your CSV export file is being prepared. Please wait.',
    NOT_TRIGGERED: '',
    SUCCESS: 'Your CSV export file is ready. Click on download to view file.',
    FAILURE:
      'Your CSV export file could not be prepared. Please export the file again.'
  }

  const showDownloadBtn =
    !_.isEmpty(presignedURL) && progress?.status === 'SUCCESS'

  return (
    <div
      className="download-progress-container"
      style={{
        backgroundColor: COLOR_CODE_MAP[progressState]
      }}
    >
      <span className="download-progress-status">
        <span className="download-progress-status-icon">
          <i className={`fa-solid ${ICON_MAP[progressState]}`} />
        </span>
        <span className="download-progress-status-text">
          {MESSAGE_MAP[progressState]}
        </span>
      </span>
      {showDownloadBtn && (
        <button
          type="button"
          className="download-progress-btn"
          onClick={() => {
            services.getCSVDownload().then(() => {
              setProgress()
              const fileName = `Full report.csv`
              const link = document.createElement('a')
              link.href = presignedURL
              link.download = fileName
              link.target = 1
              document.body.appendChild(link)
              link.click()

              setTimeout(() => {
                getCSVDownloadableURL({ is_downloaded: true })
              }, 2000)
            })
          }}
        >
          <i className="fa-solid fa-download" />
          <span>Download File</span>
        </button>
      )}
    </div>
  )
}

export default CSVDownloadProgress
